import { ApolloProvider } from '@apollo/client/react'
import client from './client'
import type { ReactNode } from 'react'
import type { ApolloClient } from '@apollo/client'

export function getContext() {
  return {
    apolloClient: client,
  }
}

export function Provider({
  children,
  apolloClient,
}: {
  children: ReactNode
  apolloClient: ApolloClient
}) {
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
